// extracted by mini-css-extract-plugin
export var quantityInput = "_nb-0";